import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { EmployeeListComponent } from './employee-list/employee-list.component';
import { EmployeeDetailComponent } from './employee-detail/employee-detail.component';
import { PayrollListComponent } from './payroll-list/payroll-list.component';
import { PayrollDetailComponent } from './payroll-detail/payroll-detail.component';
import { IncidentsComponent } from './incidents/incidents.component';
import { PayrollReceiptsListComponent } from './payroll-receipts-list/payroll-receipts-list.component';
import { EmployeeDocumentViewComponent } from './employee-document-view/employee-document-view.component';
import { PayrollConfigComponent } from './payroll-config/payroll-config.component';
import { PayrollPeriodsListComponent } from './payroll-periods-list/payroll-periods-list.component';
import { PayrollPeriodReceiptsComponent } from './payroll-period-receipts/payroll-period-receipts.component';

const routes: Routes = [{
    path: "payroll-receipts", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "", component: PayrollReceiptsListComponent, data: { module: "Recibos electrónicos", accion: "Listado de Recibos", type: "list" }
    }]
}, {
    path: "payroll-periods", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "", component: PayrollPeriodsListComponent, data: { module: "Administrador de periodos", accion: "Listado de Periodos", type: "list" }
    }, {
        path: ":id/receipts", component: PayrollPeriodReceiptsComponent, data: { module: "Administrador de periodos", accion: "Consulta de periodo", type: "period-receipts" }
    }]
}, {
    path: "payroll-config", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "", component: PayrollConfigComponent, data: { module: "Parámetros de nómina", accion: "Configuración general", type: "settings" }
    }]
}, {
    path: "employee", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "list", component: EmployeeListComponent, data: { module: "Recursos Humanos", accion: "Listado de Colaboradores", type: "list" }
    }, {
        // La ruta estática "new" debe declararse antes que ":id" para que Angular no la
        // interprete como un parámetro de id.
        path: "new", component: EmployeeDetailComponent, data: { module: "Recursos Humanos", accion: "Registrar Colaborador", type: "create" }
    }, {
        // Rutas de nómina: al tener más segmentos que ":id" no compiten con él en el
        // matching de Angular (que empareja por cantidad exacta de segmentos), así que
        // el orden respecto a ":id" no es relevante.
        path: ":id/payroll", component: PayrollListComponent, data: { module: "Recursos Humanos", accion: "Nómina del Colaborador", type: "payroll-list" }
    }, {
        path: ":id/payroll/:payrollId", component: PayrollDetailComponent, data: { module: "Recursos Humanos", accion: "Recibo de Nómina", type: "payroll-detail" }
    }, {
        // Historial de incidencias: mismo criterio que las rutas de nómina (más
        // segmentos que ":id", así que el orden respecto a ":id" no es relevante).
        path: ":id/incidents", component: IncidentsComponent, data: { module: "Recursos Humanos", accion: "Historial de Incidencias", type: "incidents" }
    }, {
        // Visor de documento de contratación: mismo criterio que nómina/incidencias (más
        // segmentos que ":id", así que el orden respecto a ":id" no es relevante).
        path: ":id/document/:type", component: EmployeeDocumentViewComponent, data: { module: "Recursos Humanos", accion: "Documentación de Contratación", type: "document-view" }
    }, {
        // Placeholder de detalle (Fase 2.2): evita que "Colaborador" / "Nómina del colaborador" rompan la navegación.
        path: ":id", component: EmployeeDetailComponent, data: { module: "Recursos Humanos", accion: "Detalle del Colaborador", type: "view" }
    }]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EmployeeRoutingModule { }
